/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../routes/root-layout/root-layout.tsx";
import { Route as rootLayoutAuthorizationGateRouteImport } from "./../routes/root-layout/authorization-gate.tsx";
import { Route as wizardWizardLayoutRouteImport } from "./../routes/wizard/wizard-layout.tsx";
import { Route as retrievalExplorerRetrievalExplorerPageRouteImport } from "./../routes/retrieval-explorer/retrieval-explorer-page.tsx";
import { Route as projectsRedirectRouteImport } from "./../routes/projects-redirect.tsx";
import { Route as auth0CallbackPageRouteImport } from "./../routes/auth0-callback-page.tsx";
import { Route as homePageHomePageRouteImport } from "./../routes/home-page/home-page.tsx";
import { Route as wizardQueuePageWizardQueuePageRouteImport } from "./../routes/wizard/queue-page/wizard-queue-page.tsx";
import { Route as wizardGoPageWizardGoPageRouteImport } from "./../routes/wizard/go-page/wizard-go-page.tsx";
import { Route as wizardAdminWizardAdminLayoutRouteImport } from "./../routes/wizard/admin/wizard-admin-layout.tsx";
import { Route as toolsAdminToolsAdminLayoutRouteImport } from "./../routes/tools/admin/tools-admin-layout.tsx";
import { Route as packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteImport } from "./../routes/package-store/package-family-editor/layout/package-family-editor-layout.tsx";
import { Route as orgsOrgLayoutRouteImport } from "./../routes/orgs/org-layout.tsx";
import { Route as workEmailRequiredPageRouteImport } from "./../routes/work-email-required-page.tsx";
import { Route as wizardHomePageWizardHomePageRouteImport } from "./../routes/wizard/home-page/wizard-home-page.tsx";
import { Route as verifyEmailPageRouteImport } from "./../routes/verify-email-page.tsx";
import { Route as tagsTagsPageRouteImport } from "./../routes/tags/tags-page.tsx";
import { Route as packageStoreHomePackageStoreHomeRouteImport } from "./../routes/package-store/home/package-store-home.tsx";
import { Route as manufacturerIndexManufacturerIndexRouteImport } from "./../routes/manufacturer-index/manufacturer-index.tsx";
import { Route as loggedOutPageRouteImport } from "./../routes/logged-out-page.tsx";
import { Route as logOutPageRouteImport } from "./../routes/log-out-page.tsx";
import { Route as logInPageRouteImport } from "./../routes/log-in-page.tsx";
import { Route as documentsPendingPageRouteImport } from "./../routes/documents-pending-page.tsx";
import { Route as pdfElementsViewerPdfElementsViewerPageRouteImport } from "./../routes/pdf-elements-viewer/pdf-elements-viewer-page.tsx";
import { Route as wizardAdminGeneralPageWizardAdminGeneralPageRouteImport } from "./../routes/wizard/admin/general-page/wizard-admin-general-page.tsx";
import { Route as packageStorePackageFamilyEditorRootRedirectRouteImport } from "./../routes/package-store/package-family-editor/root-redirect.tsx";
import { Route as orgsOrgHomePageRouteImport } from "./../routes/orgs/org-home-page.tsx";
import { Route as wizardAdminProjectsPageWizardAdminProjectsPageRouteImport } from "./../routes/wizard/admin/projects-page/wizard-admin-projects-page.tsx";
import { Route as wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRouteImport } from "./../routes/wizard/admin/projects-page/package-review/wizard-admin-package-review-page.tsx";
import { Route as agentConversationsAgentConversationPageRouteImport } from "./../routes/agent-conversations/agent-conversation-page.tsx";
import { Route as packageStorePackageEditorLayoutPackageEditorLayoutRouteImport } from "./../routes/package-store/package-editor/layout/package-editor-layout.tsx";
import { Route as projectsLayoutProjectLayoutRouteImport } from "./../routes/projects/layout/project-layout.tsx";
import { Route as wizardAdminUsersPageWizardAdminUsersPageRouteImport } from "./../routes/wizard/admin/users-page/wizard-admin-users-page.tsx";
import { Route as wizardAdminUserThroughputPageWizardAdminUserThroughputPageRouteImport } from "./../routes/wizard/admin/user-throughput-page/wizard-admin-user-throughput-page.tsx";
import { Route as wizardAdminPlansPageWizardAdminPlansPageRouteImport } from "./../routes/wizard/admin/plans-page/wizard-admin-plans-page.tsx";
import { Route as wizardAdminMembersPageWizardAdminMembersPageRouteImport } from "./../routes/wizard/admin/members-page/wizard-admin-members-page.tsx";
import { Route as wizardAdminEvalPageWizardAdminEvalPageRouteImport } from "./../routes/wizard/admin/eval-page/wizard-admin-eval-page.tsx";
import { Route as wizardAdminErrorCodesPageWizardAdminErrorCodesPageRouteImport } from "./../routes/wizard/admin/error-codes-page/wizard-admin-error-codes-page.tsx";
import { Route as wizardAdminDataSpecsPageWizardAdminDataSpecsPageRouteImport } from "./../routes/wizard/admin/data-specs-page/wizard-admin-data-specs-page.tsx";
import { Route as toolsAdminPipelineOpsPageAdminPipelineOpsPageRouteImport } from "./../routes/tools/admin/pipeline-ops-page/admin-pipeline-ops-page.tsx";
import { Route as toolsAdminCustomerBomPageAdminCustomerBomPageRouteImport } from "./../routes/tools/admin/customer-bom-page/admin-customer-bom-page.tsx";
import { Route as packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRouteImport } from "./../routes/package-store/package-family-editor/raw-tab/package-family-editor-raw-tab.tsx";
import { Route as packageStorePackageFamilyEditorPackagesTabPackagesTabRouteImport } from "./../routes/package-store/package-family-editor/packages-tab/packages-tab.tsx";
import { Route as packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRouteImport } from "./../routes/package-store/package-family-editor/general-tab/family-general-tab.tsx";
import { Route as orgsSettingsOrgSettingsPageRouteImport } from "./../routes/orgs/settings/org-settings-page.tsx";
import { Route as projectsHomeProjectsHomePageRouteImport } from "./../routes/projects/home/projects-home-page.tsx";
import { Route as wizardAdminEvalPageWizardAdminEvalOperatorPageRouteImport } from "./../routes/wizard/admin/eval-page/wizard-admin-eval-operator-page.tsx";
import { Route as projectsFileUploadNewProjectUploadPageRouteImport } from "./../routes/projects/file-upload/new-project-upload-page.tsx";
import { Route as packageStorePackageEditorRootRedirectRouteImport } from "./../routes/package-store/package-editor/root-redirect.tsx";
import { Route as projectsProjectOverviewRootRedirectRouteImport } from "./../routes/projects/project-overview/root-redirect.tsx";
import { Route as orgsBillingPricingOptionsPagePricingOptionsPageRouteImport } from "./../routes/orgs/billing/pricing-options-page/pricing-options-page.tsx";
import { Route as projectsRevisionLayoutProjectRevisionLayoutRouteImport } from "./../routes/projects/revision-layout/project-revision-layout.tsx";
import { Route as packageStorePackageEditorSignalsTabSignalsTabRouteImport } from "./../routes/package-store/package-editor/signals-tab/signals-tab.tsx";
import { Route as packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRouteImport } from "./../routes/package-store/package-editor/signal-drive-modes-tab/signal-drive-modes-tab.tsx";
import { Route as packageStorePackageEditorResourcesTabResourcesTabRouteImport } from "./../routes/package-store/package-editor/resources-tab/resources-tab.tsx";
import { Route as packageStorePackageEditorRawTabPackageEditorRawTabRouteImport } from "./../routes/package-store/package-editor/raw-tab/package-editor-raw-tab.tsx";
import { Route as packageStorePackageEditorPinoutTabPinoutTabRouteImport } from "./../routes/package-store/package-editor/pinout-tab/pinout-tab.tsx";
import { Route as packageStorePackageEditorParametersTabParametersTabRouteImport } from "./../routes/package-store/package-editor/parameters-tab/parameters-tab.tsx";
import { Route as packageStorePackageEditorModesTabModesTabRouteImport } from "./../routes/package-store/package-editor/modes-tab/modes-tab.tsx";
import { Route as packageStorePackageEditorModelsTabModelsTabRouteImport } from "./../routes/package-store/package-editor/models-tab/models-tab.tsx";
import { Route as packageStorePackageEditorImplementationRulesTabImplementationRulesTabRouteImport } from "./../routes/package-store/package-editor/implementation-rules-tab/implementation-rules-tab.tsx";
import { Route as packageStorePackageEditorGeneralTabGeneralTabRouteImport } from "./../routes/package-store/package-editor/general-tab/general-tab.tsx";
import { Route as packageStorePackageEditorFunctionsTabFunctionsTabRouteImport } from "./../routes/package-store/package-editor/functions-tab/functions-tab.tsx";
import { Route as packageStorePackageEditorDatasheetTabDatasheetTabRouteImport } from "./../routes/package-store/package-editor/datasheet-tab/datasheet-tab.tsx";
import { Route as packageStorePackageEditorBoundariesTabBoundariesTabRouteImport } from "./../routes/package-store/package-editor/boundaries-tab/boundaries-tab.tsx";
import { Route as projectsProjectOverviewProjectOverviewPageRouteImport } from "./../routes/projects/project-overview/project-overview-page.tsx";
import { Route as projectsFileUploadRevFileUploadPageRouteImport } from "./../routes/projects/file-upload/rev-file-upload-page.tsx";
import { Route as resultsAnalysisResultsPageAnalysisResultsPageRouteImport } from "./../routes/results/analysis-results-page/analysis-results-page.tsx";
import { Route as resolutionEditorResolutionEditorPageResolutionEditorPageRouteImport } from "./../routes/resolution-editor/resolution-editor-page/resolution-editor-page.tsx";
import { Route as designCanvasDesignCanvasPageRouteImport } from "./../routes/design-canvas/design-canvas-page.tsx";
import { Route as blockDiagramBlockDiagramPageRouteImport } from "./../routes/block-diagram/block-diagram-page.tsx";
import { Route as aiFindingsAiFindingsPageAiFindingsPageRouteImport } from "./../routes/ai-findings/ai-findings-page/ai-findings-page.tsx";
import { Route as projectsRevisionLayoutRootRedirectRouteImport } from "./../routes/projects/revision-layout/root-redirect.tsx";
import { Route as componentInferenceComponentInferencePageRouteImport } from "./../routes/component-inference/component-inference-page.tsx";

const rootLayoutAuthorizationGateRoute =
  rootLayoutAuthorizationGateRouteImport.update({
    id: "/_authorization-gate",
    getParentRoute: () => rootRouteImport,
  } as any);
const wizardWizardLayoutRoute = wizardWizardLayoutRouteImport.update({
  id: "/wizard",
  path: "/wizard",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const retrievalExplorerRetrievalExplorerPageRoute =
  retrievalExplorerRetrievalExplorerPageRouteImport.update({
    id: "/retrieval-explorer",
    path: "/retrieval-explorer",
    getParentRoute: () => rootLayoutAuthorizationGateRoute,
  } as any);
const projectsRedirectRoute = projectsRedirectRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const auth0CallbackPageRoute = auth0CallbackPageRouteImport.update({
  id: "/callback",
  path: "/callback",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const homePageHomePageRoute = homePageHomePageRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const wizardQueuePageWizardQueuePageRoute =
  wizardQueuePageWizardQueuePageRouteImport.update({
    id: "/queue",
    path: "/queue",
    getParentRoute: () => wizardWizardLayoutRoute,
  } as any);
const wizardGoPageWizardGoPageRoute =
  wizardGoPageWizardGoPageRouteImport.update({
    id: "/go",
    path: "/go",
    getParentRoute: () => wizardWizardLayoutRoute,
  } as any);
const wizardAdminWizardAdminLayoutRoute =
  wizardAdminWizardAdminLayoutRouteImport.update({
    id: "/admin",
    path: "/admin",
    getParentRoute: () => wizardWizardLayoutRoute,
  } as any);
const toolsAdminToolsAdminLayoutRoute =
  toolsAdminToolsAdminLayoutRouteImport.update({
    id: "/tools/admin",
    path: "/tools/admin",
    getParentRoute: () => rootLayoutAuthorizationGateRoute,
  } as any);
const packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute =
  packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteImport.update(
    {
      id: "/package-store/$packageFamilyId",
      path: "/package-store/$packageFamilyId",
      getParentRoute: () => rootLayoutAuthorizationGateRoute,
    } as any,
  );
const orgsOrgLayoutRoute = orgsOrgLayoutRouteImport.update({
  id: "/orgs/$orgName",
  path: "/orgs/$orgName",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const workEmailRequiredPageRoute = workEmailRequiredPageRouteImport.update({
  id: "/work-email-required/",
  path: "/work-email-required/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const wizardHomePageWizardHomePageRoute =
  wizardHomePageWizardHomePageRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => wizardWizardLayoutRoute,
  } as any);
const verifyEmailPageRoute = verifyEmailPageRouteImport.update({
  id: "/verify-email/",
  path: "/verify-email/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const tagsTagsPageRoute = tagsTagsPageRouteImport.update({
  id: "/package-tags/",
  path: "/package-tags/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const packageStoreHomePackageStoreHomeRoute =
  packageStoreHomePackageStoreHomeRouteImport.update({
    id: "/package-store/",
    path: "/package-store/",
    getParentRoute: () => rootLayoutAuthorizationGateRoute,
  } as any);
const manufacturerIndexManufacturerIndexRoute =
  manufacturerIndexManufacturerIndexRouteImport.update({
    id: "/manufacturers/",
    path: "/manufacturers/",
    getParentRoute: () => rootLayoutAuthorizationGateRoute,
  } as any);
const loggedOutPageRoute = loggedOutPageRouteImport.update({
  id: "/logged-out/",
  path: "/logged-out/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const logOutPageRoute = logOutPageRouteImport.update({
  id: "/log-out/",
  path: "/log-out/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const logInPageRoute = logInPageRouteImport.update({
  id: "/log-in/",
  path: "/log-in/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const documentsPendingPageRoute = documentsPendingPageRouteImport.update({
  id: "/documents-pending/",
  path: "/documents-pending/",
  getParentRoute: () => rootLayoutAuthorizationGateRoute,
} as any);
const pdfElementsViewerPdfElementsViewerPageRoute =
  pdfElementsViewerPdfElementsViewerPageRouteImport.update({
    id: "/file/$fileId/elements",
    path: "/file/$fileId/elements",
    getParentRoute: () => rootLayoutAuthorizationGateRoute,
  } as any);
const wizardAdminGeneralPageWizardAdminGeneralPageRoute =
  wizardAdminGeneralPageWizardAdminGeneralPageRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const packageStorePackageFamilyEditorRootRedirectRoute =
  packageStorePackageFamilyEditorRootRedirectRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute,
  } as any);
const orgsOrgHomePageRoute = orgsOrgHomePageRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => orgsOrgLayoutRoute,
} as any);
const wizardAdminProjectsPageWizardAdminProjectsPageRoute =
  wizardAdminProjectsPageWizardAdminProjectsPageRouteImport.update({
    id: "/projects/{-$revisionId}",
    path: "/projects/{-$revisionId}",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute =
  wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRouteImport.update(
    {
      id: "/package-review/{-$revisionId}",
      path: "/package-review/{-$revisionId}",
      getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
    } as any,
  );
const agentConversationsAgentConversationPageRoute =
  agentConversationsAgentConversationPageRouteImport.update({
    id: "/user/$ownerId/conversations/$conversationId",
    path: "/user/$ownerId/conversations/$conversationId",
    getParentRoute: () => rootLayoutAuthorizationGateRoute,
  } as any);
const packageStorePackageEditorLayoutPackageEditorLayoutRoute =
  packageStorePackageEditorLayoutPackageEditorLayoutRouteImport.update({
    id: "/packages/$packageId",
    path: "/packages/$packageId",
    getParentRoute: () =>
      packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute,
  } as any);
const projectsLayoutProjectLayoutRoute =
  projectsLayoutProjectLayoutRouteImport.update({
    id: "/projects/$projectId",
    path: "/projects/$projectId",
    getParentRoute: () => orgsOrgLayoutRoute,
  } as any);
const wizardAdminUsersPageWizardAdminUsersPageRoute =
  wizardAdminUsersPageWizardAdminUsersPageRouteImport.update({
    id: "/users/",
    path: "/users/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute =
  wizardAdminUserThroughputPageWizardAdminUserThroughputPageRouteImport.update({
    id: "/user-throughput/",
    path: "/user-throughput/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminPlansPageWizardAdminPlansPageRoute =
  wizardAdminPlansPageWizardAdminPlansPageRouteImport.update({
    id: "/plans/",
    path: "/plans/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminMembersPageWizardAdminMembersPageRoute =
  wizardAdminMembersPageWizardAdminMembersPageRouteImport.update({
    id: "/members/",
    path: "/members/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminEvalPageWizardAdminEvalPageRoute =
  wizardAdminEvalPageWizardAdminEvalPageRouteImport.update({
    id: "/eval/",
    path: "/eval/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute =
  wizardAdminErrorCodesPageWizardAdminErrorCodesPageRouteImport.update({
    id: "/error-codes/",
    path: "/error-codes/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute =
  wizardAdminDataSpecsPageWizardAdminDataSpecsPageRouteImport.update({
    id: "/data-specs/",
    path: "/data-specs/",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute =
  toolsAdminPipelineOpsPageAdminPipelineOpsPageRouteImport.update({
    id: "/pipeline-ops/",
    path: "/pipeline-ops/",
    getParentRoute: () => toolsAdminToolsAdminLayoutRoute,
  } as any);
const toolsAdminCustomerBomPageAdminCustomerBomPageRoute =
  toolsAdminCustomerBomPageAdminCustomerBomPageRouteImport.update({
    id: "/customer-bom/",
    path: "/customer-bom/",
    getParentRoute: () => toolsAdminToolsAdminLayoutRoute,
  } as any);
const packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute =
  packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRouteImport.update(
    {
      id: "/raw/",
      path: "/raw/",
      getParentRoute: () =>
        packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute,
    } as any,
  );
const packageStorePackageFamilyEditorPackagesTabPackagesTabRoute =
  packageStorePackageFamilyEditorPackagesTabPackagesTabRouteImport.update({
    id: "/packages/",
    path: "/packages/",
    getParentRoute: () =>
      packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute,
  } as any);
const packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute =
  packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRouteImport.update({
    id: "/general/",
    path: "/general/",
    getParentRoute: () =>
      packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute,
  } as any);
const orgsSettingsOrgSettingsPageRoute =
  orgsSettingsOrgSettingsPageRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => orgsOrgLayoutRoute,
  } as any);
const projectsHomeProjectsHomePageRoute =
  projectsHomeProjectsHomePageRouteImport.update({
    id: "/projects/",
    path: "/projects/",
    getParentRoute: () => orgsOrgLayoutRoute,
  } as any);
const wizardAdminEvalPageWizardAdminEvalOperatorPageRoute =
  wizardAdminEvalPageWizardAdminEvalOperatorPageRouteImport.update({
    id: "/eval/operator/$userId",
    path: "/eval/operator/$userId",
    getParentRoute: () => wizardAdminWizardAdminLayoutRoute,
  } as any);
const projectsFileUploadNewProjectUploadPageRoute =
  projectsFileUploadNewProjectUploadPageRouteImport.update({
    id: "/projects/new/upload",
    path: "/projects/new/upload",
    getParentRoute: () => orgsOrgLayoutRoute,
  } as any);
const packageStorePackageEditorRootRedirectRoute =
  packageStorePackageEditorRootRedirectRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const projectsProjectOverviewRootRedirectRoute =
  projectsProjectOverviewRootRedirectRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => projectsLayoutProjectLayoutRoute,
  } as any);
const orgsBillingPricingOptionsPagePricingOptionsPageRoute =
  orgsBillingPricingOptionsPagePricingOptionsPageRouteImport.update({
    id: "/billing/plans/",
    path: "/billing/plans/",
    getParentRoute: () => orgsOrgLayoutRoute,
  } as any);
const projectsRevisionLayoutProjectRevisionLayoutRoute =
  projectsRevisionLayoutProjectRevisionLayoutRouteImport.update({
    id: "/revisions/$revisionId",
    path: "/revisions/$revisionId",
    getParentRoute: () => projectsLayoutProjectLayoutRoute,
  } as any);
const packageStorePackageEditorSignalsTabSignalsTabRoute =
  packageStorePackageEditorSignalsTabSignalsTabRouteImport.update({
    id: "/signals/",
    path: "/signals/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute =
  packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRouteImport.update(
    {
      id: "/signal-drive-modes/",
      path: "/signal-drive-modes/",
      getParentRoute: () =>
        packageStorePackageEditorLayoutPackageEditorLayoutRoute,
    } as any,
  );
const packageStorePackageEditorResourcesTabResourcesTabRoute =
  packageStorePackageEditorResourcesTabResourcesTabRouteImport.update({
    id: "/resources/",
    path: "/resources/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorRawTabPackageEditorRawTabRoute =
  packageStorePackageEditorRawTabPackageEditorRawTabRouteImport.update({
    id: "/raw/",
    path: "/raw/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorPinoutTabPinoutTabRoute =
  packageStorePackageEditorPinoutTabPinoutTabRouteImport.update({
    id: "/pinout/",
    path: "/pinout/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorParametersTabParametersTabRoute =
  packageStorePackageEditorParametersTabParametersTabRouteImport.update({
    id: "/parameters/",
    path: "/parameters/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorModesTabModesTabRoute =
  packageStorePackageEditorModesTabModesTabRouteImport.update({
    id: "/modes/",
    path: "/modes/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorModelsTabModelsTabRoute =
  packageStorePackageEditorModelsTabModelsTabRouteImport.update({
    id: "/models/",
    path: "/models/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute =
  packageStorePackageEditorImplementationRulesTabImplementationRulesTabRouteImport.update(
    {
      id: "/implementation-rules/",
      path: "/implementation-rules/",
      getParentRoute: () =>
        packageStorePackageEditorLayoutPackageEditorLayoutRoute,
    } as any,
  );
const packageStorePackageEditorGeneralTabGeneralTabRoute =
  packageStorePackageEditorGeneralTabGeneralTabRouteImport.update({
    id: "/general/",
    path: "/general/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorFunctionsTabFunctionsTabRoute =
  packageStorePackageEditorFunctionsTabFunctionsTabRouteImport.update({
    id: "/functions/",
    path: "/functions/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorDatasheetTabDatasheetTabRoute =
  packageStorePackageEditorDatasheetTabDatasheetTabRouteImport.update({
    id: "/datasheet/",
    path: "/datasheet/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const packageStorePackageEditorBoundariesTabBoundariesTabRoute =
  packageStorePackageEditorBoundariesTabBoundariesTabRouteImport.update({
    id: "/boundaries/",
    path: "/boundaries/",
    getParentRoute: () =>
      packageStorePackageEditorLayoutPackageEditorLayoutRoute,
  } as any);
const projectsProjectOverviewProjectOverviewPageRoute =
  projectsProjectOverviewProjectOverviewPageRouteImport.update({
    id: "/overview/",
    path: "/overview/",
    getParentRoute: () => projectsLayoutProjectLayoutRoute,
  } as any);
const projectsFileUploadRevFileUploadPageRoute =
  projectsFileUploadRevFileUploadPageRouteImport.update({
    id: "/upload",
    path: "/upload",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const resultsAnalysisResultsPageAnalysisResultsPageRoute =
  resultsAnalysisResultsPageAnalysisResultsPageRouteImport.update({
    id: "/results",
    path: "/results",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const resolutionEditorResolutionEditorPageResolutionEditorPageRoute =
  resolutionEditorResolutionEditorPageResolutionEditorPageRouteImport.update({
    id: "/resolution-editor",
    path: "/resolution-editor",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const designCanvasDesignCanvasPageRoute =
  designCanvasDesignCanvasPageRouteImport.update({
    id: "/design-canvas",
    path: "/design-canvas",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const blockDiagramBlockDiagramPageRoute =
  blockDiagramBlockDiagramPageRouteImport.update({
    id: "/block-diagram",
    path: "/block-diagram",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const aiFindingsAiFindingsPageAiFindingsPageRoute =
  aiFindingsAiFindingsPageAiFindingsPageRouteImport.update({
    id: "/ai-findings",
    path: "/ai-findings",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const projectsRevisionLayoutRootRedirectRoute =
  projectsRevisionLayoutRootRedirectRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);
const componentInferenceComponentInferencePageRoute =
  componentInferenceComponentInferencePageRouteImport.update({
    id: "/component-inference/$referenceDesignator",
    path: "/component-inference/$referenceDesignator",
    getParentRoute: () => projectsRevisionLayoutProjectRevisionLayoutRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof homePageHomePageRoute;
  "/callback": typeof auth0CallbackPageRoute;
  "/projects": typeof projectsRedirectRoute;
  "/retrieval-explorer": typeof retrievalExplorerRetrievalExplorerPageRoute;
  "/wizard": typeof wizardWizardLayoutRouteWithChildren;
  "/documents-pending/": typeof documentsPendingPageRoute;
  "/log-in/": typeof logInPageRoute;
  "/log-out/": typeof logOutPageRoute;
  "/logged-out/": typeof loggedOutPageRoute;
  "/manufacturers/": typeof manufacturerIndexManufacturerIndexRoute;
  "/package-store/": typeof packageStoreHomePackageStoreHomeRoute;
  "/package-tags/": typeof tagsTagsPageRoute;
  "/verify-email/": typeof verifyEmailPageRoute;
  "/wizard/": typeof wizardHomePageWizardHomePageRoute;
  "/work-email-required/": typeof workEmailRequiredPageRoute;
  "/orgs/$orgName": typeof orgsOrgLayoutRouteWithChildren;
  "/package-store/$packageFamilyId": typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteWithChildren;
  "/tools/admin": typeof toolsAdminToolsAdminLayoutRouteWithChildren;
  "/wizard/admin": typeof wizardAdminWizardAdminLayoutRouteWithChildren;
  "/wizard/go": typeof wizardGoPageWizardGoPageRoute;
  "/wizard/queue": typeof wizardQueuePageWizardQueuePageRoute;
  "/orgs/$orgName/": typeof orgsOrgHomePageRoute;
  "/package-store/$packageFamilyId/": typeof packageStorePackageFamilyEditorRootRedirectRoute;
  "/wizard/admin/": typeof wizardAdminGeneralPageWizardAdminGeneralPageRoute;
  "/file/$fileId/elements": typeof pdfElementsViewerPdfElementsViewerPageRoute;
  "/orgs/$orgName/projects/": typeof projectsHomeProjectsHomePageRoute;
  "/orgs/$orgName/settings/": typeof orgsSettingsOrgSettingsPageRoute;
  "/package-store/$packageFamilyId/general/": typeof packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute;
  "/package-store/$packageFamilyId/packages/": typeof packageStorePackageFamilyEditorPackagesTabPackagesTabRoute;
  "/package-store/$packageFamilyId/raw/": typeof packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute;
  "/tools/admin/customer-bom/": typeof toolsAdminCustomerBomPageAdminCustomerBomPageRoute;
  "/tools/admin/pipeline-ops/": typeof toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute;
  "/wizard/admin/data-specs/": typeof wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute;
  "/wizard/admin/error-codes/": typeof wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute;
  "/wizard/admin/eval/": typeof wizardAdminEvalPageWizardAdminEvalPageRoute;
  "/wizard/admin/members/": typeof wizardAdminMembersPageWizardAdminMembersPageRoute;
  "/wizard/admin/plans/": typeof wizardAdminPlansPageWizardAdminPlansPageRoute;
  "/wizard/admin/user-throughput/": typeof wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute;
  "/wizard/admin/users/": typeof wizardAdminUsersPageWizardAdminUsersPageRoute;
  "/orgs/$orgName/projects/$projectId": typeof projectsLayoutProjectLayoutRouteWithChildren;
  "/package-store/$packageFamilyId/packages/$packageId": typeof packageStorePackageEditorLayoutPackageEditorLayoutRouteWithChildren;
  "/user/$ownerId/conversations/$conversationId": typeof agentConversationsAgentConversationPageRoute;
  "/wizard/admin/package-review/{-$revisionId}": typeof wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute;
  "/wizard/admin/projects/{-$revisionId}": typeof wizardAdminProjectsPageWizardAdminProjectsPageRoute;
  "/orgs/$orgName/billing/plans/": typeof orgsBillingPricingOptionsPagePricingOptionsPageRoute;
  "/orgs/$orgName/projects/$projectId/": typeof projectsProjectOverviewRootRedirectRoute;
  "/package-store/$packageFamilyId/packages/$packageId/": typeof packageStorePackageEditorRootRedirectRoute;
  "/orgs/$orgName/projects/new/upload": typeof projectsFileUploadNewProjectUploadPageRoute;
  "/wizard/admin/eval/operator/$userId": typeof wizardAdminEvalPageWizardAdminEvalOperatorPageRoute;
  "/orgs/$orgName/projects/$projectId/overview/": typeof projectsProjectOverviewProjectOverviewPageRoute;
  "/package-store/$packageFamilyId/packages/$packageId/boundaries/": typeof packageStorePackageEditorBoundariesTabBoundariesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/datasheet/": typeof packageStorePackageEditorDatasheetTabDatasheetTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/functions/": typeof packageStorePackageEditorFunctionsTabFunctionsTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/general/": typeof packageStorePackageEditorGeneralTabGeneralTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/implementation-rules/": typeof packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/models/": typeof packageStorePackageEditorModelsTabModelsTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/modes/": typeof packageStorePackageEditorModesTabModesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/parameters/": typeof packageStorePackageEditorParametersTabParametersTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/pinout/": typeof packageStorePackageEditorPinoutTabPinoutTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/raw/": typeof packageStorePackageEditorRawTabPackageEditorRawTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/resources/": typeof packageStorePackageEditorResourcesTabResourcesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/": typeof packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/signals/": typeof packageStorePackageEditorSignalsTabSignalsTabRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId": typeof projectsRevisionLayoutProjectRevisionLayoutRouteWithChildren;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/": typeof projectsRevisionLayoutRootRedirectRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings": typeof aiFindingsAiFindingsPageAiFindingsPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram": typeof blockDiagramBlockDiagramPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas": typeof designCanvasDesignCanvasPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor": typeof resolutionEditorResolutionEditorPageResolutionEditorPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/results": typeof resultsAnalysisResultsPageAnalysisResultsPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload": typeof projectsFileUploadRevFileUploadPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator": typeof componentInferenceComponentInferencePageRoute;
}
export interface FileRoutesByTo {
  "/": typeof homePageHomePageRoute;
  "/callback": typeof auth0CallbackPageRoute;
  "/projects": typeof projectsRedirectRoute;
  "/retrieval-explorer": typeof retrievalExplorerRetrievalExplorerPageRoute;
  "/documents-pending": typeof documentsPendingPageRoute;
  "/log-in": typeof logInPageRoute;
  "/log-out": typeof logOutPageRoute;
  "/logged-out": typeof loggedOutPageRoute;
  "/manufacturers": typeof manufacturerIndexManufacturerIndexRoute;
  "/package-store": typeof packageStoreHomePackageStoreHomeRoute;
  "/package-tags": typeof tagsTagsPageRoute;
  "/verify-email": typeof verifyEmailPageRoute;
  "/wizard": typeof wizardHomePageWizardHomePageRoute;
  "/work-email-required": typeof workEmailRequiredPageRoute;
  "/tools/admin": typeof toolsAdminToolsAdminLayoutRouteWithChildren;
  "/wizard/go": typeof wizardGoPageWizardGoPageRoute;
  "/wizard/queue": typeof wizardQueuePageWizardQueuePageRoute;
  "/orgs/$orgName": typeof orgsOrgHomePageRoute;
  "/package-store/$packageFamilyId": typeof packageStorePackageFamilyEditorRootRedirectRoute;
  "/wizard/admin": typeof wizardAdminGeneralPageWizardAdminGeneralPageRoute;
  "/file/$fileId/elements": typeof pdfElementsViewerPdfElementsViewerPageRoute;
  "/orgs/$orgName/projects": typeof projectsHomeProjectsHomePageRoute;
  "/orgs/$orgName/settings": typeof orgsSettingsOrgSettingsPageRoute;
  "/package-store/$packageFamilyId/general": typeof packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute;
  "/package-store/$packageFamilyId/packages": typeof packageStorePackageFamilyEditorPackagesTabPackagesTabRoute;
  "/package-store/$packageFamilyId/raw": typeof packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute;
  "/tools/admin/customer-bom": typeof toolsAdminCustomerBomPageAdminCustomerBomPageRoute;
  "/tools/admin/pipeline-ops": typeof toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute;
  "/wizard/admin/data-specs": typeof wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute;
  "/wizard/admin/error-codes": typeof wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute;
  "/wizard/admin/eval": typeof wizardAdminEvalPageWizardAdminEvalPageRoute;
  "/wizard/admin/members": typeof wizardAdminMembersPageWizardAdminMembersPageRoute;
  "/wizard/admin/plans": typeof wizardAdminPlansPageWizardAdminPlansPageRoute;
  "/wizard/admin/user-throughput": typeof wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute;
  "/wizard/admin/users": typeof wizardAdminUsersPageWizardAdminUsersPageRoute;
  "/user/$ownerId/conversations/$conversationId": typeof agentConversationsAgentConversationPageRoute;
  "/wizard/admin/package-review/{-$revisionId}": typeof wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute;
  "/wizard/admin/projects/{-$revisionId}": typeof wizardAdminProjectsPageWizardAdminProjectsPageRoute;
  "/orgs/$orgName/billing/plans": typeof orgsBillingPricingOptionsPagePricingOptionsPageRoute;
  "/orgs/$orgName/projects/$projectId": typeof projectsProjectOverviewRootRedirectRoute;
  "/package-store/$packageFamilyId/packages/$packageId": typeof packageStorePackageEditorRootRedirectRoute;
  "/orgs/$orgName/projects/new/upload": typeof projectsFileUploadNewProjectUploadPageRoute;
  "/wizard/admin/eval/operator/$userId": typeof wizardAdminEvalPageWizardAdminEvalOperatorPageRoute;
  "/orgs/$orgName/projects/$projectId/overview": typeof projectsProjectOverviewProjectOverviewPageRoute;
  "/package-store/$packageFamilyId/packages/$packageId/boundaries": typeof packageStorePackageEditorBoundariesTabBoundariesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/datasheet": typeof packageStorePackageEditorDatasheetTabDatasheetTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/functions": typeof packageStorePackageEditorFunctionsTabFunctionsTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/general": typeof packageStorePackageEditorGeneralTabGeneralTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/implementation-rules": typeof packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/models": typeof packageStorePackageEditorModelsTabModelsTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/modes": typeof packageStorePackageEditorModesTabModesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/parameters": typeof packageStorePackageEditorParametersTabParametersTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/pinout": typeof packageStorePackageEditorPinoutTabPinoutTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/raw": typeof packageStorePackageEditorRawTabPackageEditorRawTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/resources": typeof packageStorePackageEditorResourcesTabResourcesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes": typeof packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute;
  "/package-store/$packageFamilyId/packages/$packageId/signals": typeof packageStorePackageEditorSignalsTabSignalsTabRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId": typeof projectsRevisionLayoutRootRedirectRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings": typeof aiFindingsAiFindingsPageAiFindingsPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram": typeof blockDiagramBlockDiagramPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas": typeof designCanvasDesignCanvasPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor": typeof resolutionEditorResolutionEditorPageResolutionEditorPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/results": typeof resultsAnalysisResultsPageAnalysisResultsPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload": typeof projectsFileUploadRevFileUploadPageRoute;
  "/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator": typeof componentInferenceComponentInferencePageRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_authorization-gate": typeof rootLayoutAuthorizationGateRouteWithChildren;
  "/_authorization-gate/": typeof homePageHomePageRoute;
  "/_authorization-gate/callback": typeof auth0CallbackPageRoute;
  "/_authorization-gate/projects": typeof projectsRedirectRoute;
  "/_authorization-gate/retrieval-explorer": typeof retrievalExplorerRetrievalExplorerPageRoute;
  "/_authorization-gate/wizard": typeof wizardWizardLayoutRouteWithChildren;
  "/_authorization-gate/documents-pending/": typeof documentsPendingPageRoute;
  "/_authorization-gate/log-in/": typeof logInPageRoute;
  "/_authorization-gate/log-out/": typeof logOutPageRoute;
  "/_authorization-gate/logged-out/": typeof loggedOutPageRoute;
  "/_authorization-gate/manufacturers/": typeof manufacturerIndexManufacturerIndexRoute;
  "/_authorization-gate/package-store/": typeof packageStoreHomePackageStoreHomeRoute;
  "/_authorization-gate/package-tags/": typeof tagsTagsPageRoute;
  "/_authorization-gate/verify-email/": typeof verifyEmailPageRoute;
  "/_authorization-gate/wizard/": typeof wizardHomePageWizardHomePageRoute;
  "/_authorization-gate/work-email-required/": typeof workEmailRequiredPageRoute;
  "/_authorization-gate/orgs/$orgName": typeof orgsOrgLayoutRouteWithChildren;
  "/_authorization-gate/package-store/$packageFamilyId": typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteWithChildren;
  "/_authorization-gate/tools/admin": typeof toolsAdminToolsAdminLayoutRouteWithChildren;
  "/_authorization-gate/wizard/admin": typeof wizardAdminWizardAdminLayoutRouteWithChildren;
  "/_authorization-gate/wizard/go": typeof wizardGoPageWizardGoPageRoute;
  "/_authorization-gate/wizard/queue": typeof wizardQueuePageWizardQueuePageRoute;
  "/_authorization-gate/orgs/$orgName/": typeof orgsOrgHomePageRoute;
  "/_authorization-gate/package-store/$packageFamilyId/": typeof packageStorePackageFamilyEditorRootRedirectRoute;
  "/_authorization-gate/wizard/admin/": typeof wizardAdminGeneralPageWizardAdminGeneralPageRoute;
  "/_authorization-gate/file/$fileId/elements": typeof pdfElementsViewerPdfElementsViewerPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/": typeof projectsHomeProjectsHomePageRoute;
  "/_authorization-gate/orgs/$orgName/settings/": typeof orgsSettingsOrgSettingsPageRoute;
  "/_authorization-gate/package-store/$packageFamilyId/general/": typeof packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/": typeof packageStorePackageFamilyEditorPackagesTabPackagesTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/raw/": typeof packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute;
  "/_authorization-gate/tools/admin/customer-bom/": typeof toolsAdminCustomerBomPageAdminCustomerBomPageRoute;
  "/_authorization-gate/tools/admin/pipeline-ops/": typeof toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute;
  "/_authorization-gate/wizard/admin/data-specs/": typeof wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute;
  "/_authorization-gate/wizard/admin/error-codes/": typeof wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute;
  "/_authorization-gate/wizard/admin/eval/": typeof wizardAdminEvalPageWizardAdminEvalPageRoute;
  "/_authorization-gate/wizard/admin/members/": typeof wizardAdminMembersPageWizardAdminMembersPageRoute;
  "/_authorization-gate/wizard/admin/plans/": typeof wizardAdminPlansPageWizardAdminPlansPageRoute;
  "/_authorization-gate/wizard/admin/user-throughput/": typeof wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute;
  "/_authorization-gate/wizard/admin/users/": typeof wizardAdminUsersPageWizardAdminUsersPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId": typeof projectsLayoutProjectLayoutRouteWithChildren;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId": typeof packageStorePackageEditorLayoutPackageEditorLayoutRouteWithChildren;
  "/_authorization-gate/user/$ownerId/conversations/$conversationId": typeof agentConversationsAgentConversationPageRoute;
  "/_authorization-gate/wizard/admin/package-review/{-$revisionId}": typeof wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute;
  "/_authorization-gate/wizard/admin/projects/{-$revisionId}": typeof wizardAdminProjectsPageWizardAdminProjectsPageRoute;
  "/_authorization-gate/orgs/$orgName/billing/plans/": typeof orgsBillingPricingOptionsPagePricingOptionsPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/": typeof projectsProjectOverviewRootRedirectRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/": typeof packageStorePackageEditorRootRedirectRoute;
  "/_authorization-gate/orgs/$orgName/projects/new/upload": typeof projectsFileUploadNewProjectUploadPageRoute;
  "/_authorization-gate/wizard/admin/eval/operator/$userId": typeof wizardAdminEvalPageWizardAdminEvalOperatorPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/overview/": typeof projectsProjectOverviewProjectOverviewPageRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/boundaries/": typeof packageStorePackageEditorBoundariesTabBoundariesTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/datasheet/": typeof packageStorePackageEditorDatasheetTabDatasheetTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/functions/": typeof packageStorePackageEditorFunctionsTabFunctionsTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/general/": typeof packageStorePackageEditorGeneralTabGeneralTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/implementation-rules/": typeof packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/models/": typeof packageStorePackageEditorModelsTabModelsTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/modes/": typeof packageStorePackageEditorModesTabModesTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/parameters/": typeof packageStorePackageEditorParametersTabParametersTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/pinout/": typeof packageStorePackageEditorPinoutTabPinoutTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/raw/": typeof packageStorePackageEditorRawTabPackageEditorRawTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/resources/": typeof packageStorePackageEditorResourcesTabResourcesTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/": typeof packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute;
  "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signals/": typeof packageStorePackageEditorSignalsTabSignalsTabRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId": typeof projectsRevisionLayoutProjectRevisionLayoutRouteWithChildren;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/": typeof projectsRevisionLayoutRootRedirectRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings": typeof aiFindingsAiFindingsPageAiFindingsPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram": typeof blockDiagramBlockDiagramPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas": typeof designCanvasDesignCanvasPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor": typeof resolutionEditorResolutionEditorPageResolutionEditorPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/results": typeof resultsAnalysisResultsPageAnalysisResultsPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload": typeof projectsFileUploadRevFileUploadPageRoute;
  "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator": typeof componentInferenceComponentInferencePageRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/callback"
    | "/projects"
    | "/retrieval-explorer"
    | "/wizard"
    | "/documents-pending/"
    | "/log-in/"
    | "/log-out/"
    | "/logged-out/"
    | "/manufacturers/"
    | "/package-store/"
    | "/package-tags/"
    | "/verify-email/"
    | "/wizard/"
    | "/work-email-required/"
    | "/orgs/$orgName"
    | "/package-store/$packageFamilyId"
    | "/tools/admin"
    | "/wizard/admin"
    | "/wizard/go"
    | "/wizard/queue"
    | "/orgs/$orgName/"
    | "/package-store/$packageFamilyId/"
    | "/wizard/admin/"
    | "/file/$fileId/elements"
    | "/orgs/$orgName/projects/"
    | "/orgs/$orgName/settings/"
    | "/package-store/$packageFamilyId/general/"
    | "/package-store/$packageFamilyId/packages/"
    | "/package-store/$packageFamilyId/raw/"
    | "/tools/admin/customer-bom/"
    | "/tools/admin/pipeline-ops/"
    | "/wizard/admin/data-specs/"
    | "/wizard/admin/error-codes/"
    | "/wizard/admin/eval/"
    | "/wizard/admin/members/"
    | "/wizard/admin/plans/"
    | "/wizard/admin/user-throughput/"
    | "/wizard/admin/users/"
    | "/orgs/$orgName/projects/$projectId"
    | "/package-store/$packageFamilyId/packages/$packageId"
    | "/user/$ownerId/conversations/$conversationId"
    | "/wizard/admin/package-review/{-$revisionId}"
    | "/wizard/admin/projects/{-$revisionId}"
    | "/orgs/$orgName/billing/plans/"
    | "/orgs/$orgName/projects/$projectId/"
    | "/package-store/$packageFamilyId/packages/$packageId/"
    | "/orgs/$orgName/projects/new/upload"
    | "/wizard/admin/eval/operator/$userId"
    | "/orgs/$orgName/projects/$projectId/overview/"
    | "/package-store/$packageFamilyId/packages/$packageId/boundaries/"
    | "/package-store/$packageFamilyId/packages/$packageId/datasheet/"
    | "/package-store/$packageFamilyId/packages/$packageId/functions/"
    | "/package-store/$packageFamilyId/packages/$packageId/general/"
    | "/package-store/$packageFamilyId/packages/$packageId/implementation-rules/"
    | "/package-store/$packageFamilyId/packages/$packageId/models/"
    | "/package-store/$packageFamilyId/packages/$packageId/modes/"
    | "/package-store/$packageFamilyId/packages/$packageId/parameters/"
    | "/package-store/$packageFamilyId/packages/$packageId/pinout/"
    | "/package-store/$packageFamilyId/packages/$packageId/raw/"
    | "/package-store/$packageFamilyId/packages/$packageId/resources/"
    | "/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/"
    | "/package-store/$packageFamilyId/packages/$packageId/signals/"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/results"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/callback"
    | "/projects"
    | "/retrieval-explorer"
    | "/documents-pending"
    | "/log-in"
    | "/log-out"
    | "/logged-out"
    | "/manufacturers"
    | "/package-store"
    | "/package-tags"
    | "/verify-email"
    | "/wizard"
    | "/work-email-required"
    | "/tools/admin"
    | "/wizard/go"
    | "/wizard/queue"
    | "/orgs/$orgName"
    | "/package-store/$packageFamilyId"
    | "/wizard/admin"
    | "/file/$fileId/elements"
    | "/orgs/$orgName/projects"
    | "/orgs/$orgName/settings"
    | "/package-store/$packageFamilyId/general"
    | "/package-store/$packageFamilyId/packages"
    | "/package-store/$packageFamilyId/raw"
    | "/tools/admin/customer-bom"
    | "/tools/admin/pipeline-ops"
    | "/wizard/admin/data-specs"
    | "/wizard/admin/error-codes"
    | "/wizard/admin/eval"
    | "/wizard/admin/members"
    | "/wizard/admin/plans"
    | "/wizard/admin/user-throughput"
    | "/wizard/admin/users"
    | "/user/$ownerId/conversations/$conversationId"
    | "/wizard/admin/package-review/{-$revisionId}"
    | "/wizard/admin/projects/{-$revisionId}"
    | "/orgs/$orgName/billing/plans"
    | "/orgs/$orgName/projects/$projectId"
    | "/package-store/$packageFamilyId/packages/$packageId"
    | "/orgs/$orgName/projects/new/upload"
    | "/wizard/admin/eval/operator/$userId"
    | "/orgs/$orgName/projects/$projectId/overview"
    | "/package-store/$packageFamilyId/packages/$packageId/boundaries"
    | "/package-store/$packageFamilyId/packages/$packageId/datasheet"
    | "/package-store/$packageFamilyId/packages/$packageId/functions"
    | "/package-store/$packageFamilyId/packages/$packageId/general"
    | "/package-store/$packageFamilyId/packages/$packageId/implementation-rules"
    | "/package-store/$packageFamilyId/packages/$packageId/models"
    | "/package-store/$packageFamilyId/packages/$packageId/modes"
    | "/package-store/$packageFamilyId/packages/$packageId/parameters"
    | "/package-store/$packageFamilyId/packages/$packageId/pinout"
    | "/package-store/$packageFamilyId/packages/$packageId/raw"
    | "/package-store/$packageFamilyId/packages/$packageId/resources"
    | "/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes"
    | "/package-store/$packageFamilyId/packages/$packageId/signals"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/results"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload"
    | "/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator";
  id:
    | "__root__"
    | "/_authorization-gate"
    | "/_authorization-gate/"
    | "/_authorization-gate/callback"
    | "/_authorization-gate/projects"
    | "/_authorization-gate/retrieval-explorer"
    | "/_authorization-gate/wizard"
    | "/_authorization-gate/documents-pending/"
    | "/_authorization-gate/log-in/"
    | "/_authorization-gate/log-out/"
    | "/_authorization-gate/logged-out/"
    | "/_authorization-gate/manufacturers/"
    | "/_authorization-gate/package-store/"
    | "/_authorization-gate/package-tags/"
    | "/_authorization-gate/verify-email/"
    | "/_authorization-gate/wizard/"
    | "/_authorization-gate/work-email-required/"
    | "/_authorization-gate/orgs/$orgName"
    | "/_authorization-gate/package-store/$packageFamilyId"
    | "/_authorization-gate/tools/admin"
    | "/_authorization-gate/wizard/admin"
    | "/_authorization-gate/wizard/go"
    | "/_authorization-gate/wizard/queue"
    | "/_authorization-gate/orgs/$orgName/"
    | "/_authorization-gate/package-store/$packageFamilyId/"
    | "/_authorization-gate/wizard/admin/"
    | "/_authorization-gate/file/$fileId/elements"
    | "/_authorization-gate/orgs/$orgName/projects/"
    | "/_authorization-gate/orgs/$orgName/settings/"
    | "/_authorization-gate/package-store/$packageFamilyId/general/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/"
    | "/_authorization-gate/package-store/$packageFamilyId/raw/"
    | "/_authorization-gate/tools/admin/customer-bom/"
    | "/_authorization-gate/tools/admin/pipeline-ops/"
    | "/_authorization-gate/wizard/admin/data-specs/"
    | "/_authorization-gate/wizard/admin/error-codes/"
    | "/_authorization-gate/wizard/admin/eval/"
    | "/_authorization-gate/wizard/admin/members/"
    | "/_authorization-gate/wizard/admin/plans/"
    | "/_authorization-gate/wizard/admin/user-throughput/"
    | "/_authorization-gate/wizard/admin/users/"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId"
    | "/_authorization-gate/user/$ownerId/conversations/$conversationId"
    | "/_authorization-gate/wizard/admin/package-review/{-$revisionId}"
    | "/_authorization-gate/wizard/admin/projects/{-$revisionId}"
    | "/_authorization-gate/orgs/$orgName/billing/plans/"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/"
    | "/_authorization-gate/orgs/$orgName/projects/new/upload"
    | "/_authorization-gate/wizard/admin/eval/operator/$userId"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/overview/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/boundaries/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/datasheet/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/functions/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/general/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/implementation-rules/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/models/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/modes/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/parameters/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/pinout/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/raw/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/resources/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/"
    | "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signals/"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/results"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload"
    | "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  rootLayoutAuthorizationGateRoute: typeof rootLayoutAuthorizationGateRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authorization-gate": {
      id: "/_authorization-gate";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof rootLayoutAuthorizationGateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authorization-gate/wizard": {
      id: "/_authorization-gate/wizard";
      path: "/wizard";
      fullPath: "/wizard";
      preLoaderRoute: typeof wizardWizardLayoutRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/retrieval-explorer": {
      id: "/_authorization-gate/retrieval-explorer";
      path: "/retrieval-explorer";
      fullPath: "/retrieval-explorer";
      preLoaderRoute: typeof retrievalExplorerRetrievalExplorerPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/projects": {
      id: "/_authorization-gate/projects";
      path: "/projects";
      fullPath: "/projects";
      preLoaderRoute: typeof projectsRedirectRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/callback": {
      id: "/_authorization-gate/callback";
      path: "/callback";
      fullPath: "/callback";
      preLoaderRoute: typeof auth0CallbackPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/": {
      id: "/_authorization-gate/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof homePageHomePageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/wizard/queue": {
      id: "/_authorization-gate/wizard/queue";
      path: "/queue";
      fullPath: "/wizard/queue";
      preLoaderRoute: typeof wizardQueuePageWizardQueuePageRouteImport;
      parentRoute: typeof wizardWizardLayoutRoute;
    };
    "/_authorization-gate/wizard/go": {
      id: "/_authorization-gate/wizard/go";
      path: "/go";
      fullPath: "/wizard/go";
      preLoaderRoute: typeof wizardGoPageWizardGoPageRouteImport;
      parentRoute: typeof wizardWizardLayoutRoute;
    };
    "/_authorization-gate/wizard/admin": {
      id: "/_authorization-gate/wizard/admin";
      path: "/admin";
      fullPath: "/wizard/admin";
      preLoaderRoute: typeof wizardAdminWizardAdminLayoutRouteImport;
      parentRoute: typeof wizardWizardLayoutRoute;
    };
    "/_authorization-gate/tools/admin": {
      id: "/_authorization-gate/tools/admin";
      path: "/tools/admin";
      fullPath: "/tools/admin";
      preLoaderRoute: typeof toolsAdminToolsAdminLayoutRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId": {
      id: "/_authorization-gate/package-store/$packageFamilyId";
      path: "/package-store/$packageFamilyId";
      fullPath: "/package-store/$packageFamilyId";
      preLoaderRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/orgs/$orgName": {
      id: "/_authorization-gate/orgs/$orgName";
      path: "/orgs/$orgName";
      fullPath: "/orgs/$orgName";
      preLoaderRoute: typeof orgsOrgLayoutRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/work-email-required/": {
      id: "/_authorization-gate/work-email-required/";
      path: "/work-email-required";
      fullPath: "/work-email-required/";
      preLoaderRoute: typeof workEmailRequiredPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/wizard/": {
      id: "/_authorization-gate/wizard/";
      path: "/";
      fullPath: "/wizard/";
      preLoaderRoute: typeof wizardHomePageWizardHomePageRouteImport;
      parentRoute: typeof wizardWizardLayoutRoute;
    };
    "/_authorization-gate/verify-email/": {
      id: "/_authorization-gate/verify-email/";
      path: "/verify-email";
      fullPath: "/verify-email/";
      preLoaderRoute: typeof verifyEmailPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/package-tags/": {
      id: "/_authorization-gate/package-tags/";
      path: "/package-tags";
      fullPath: "/package-tags/";
      preLoaderRoute: typeof tagsTagsPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/package-store/": {
      id: "/_authorization-gate/package-store/";
      path: "/package-store";
      fullPath: "/package-store/";
      preLoaderRoute: typeof packageStoreHomePackageStoreHomeRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/manufacturers/": {
      id: "/_authorization-gate/manufacturers/";
      path: "/manufacturers";
      fullPath: "/manufacturers/";
      preLoaderRoute: typeof manufacturerIndexManufacturerIndexRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/logged-out/": {
      id: "/_authorization-gate/logged-out/";
      path: "/logged-out";
      fullPath: "/logged-out/";
      preLoaderRoute: typeof loggedOutPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/log-out/": {
      id: "/_authorization-gate/log-out/";
      path: "/log-out";
      fullPath: "/log-out/";
      preLoaderRoute: typeof logOutPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/log-in/": {
      id: "/_authorization-gate/log-in/";
      path: "/log-in";
      fullPath: "/log-in/";
      preLoaderRoute: typeof logInPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/documents-pending/": {
      id: "/_authorization-gate/documents-pending/";
      path: "/documents-pending";
      fullPath: "/documents-pending/";
      preLoaderRoute: typeof documentsPendingPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/file/$fileId/elements": {
      id: "/_authorization-gate/file/$fileId/elements";
      path: "/file/$fileId/elements";
      fullPath: "/file/$fileId/elements";
      preLoaderRoute: typeof pdfElementsViewerPdfElementsViewerPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/wizard/admin/": {
      id: "/_authorization-gate/wizard/admin/";
      path: "/";
      fullPath: "/wizard/admin/";
      preLoaderRoute: typeof wizardAdminGeneralPageWizardAdminGeneralPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/";
      path: "/";
      fullPath: "/package-store/$packageFamilyId/";
      preLoaderRoute: typeof packageStorePackageFamilyEditorRootRedirectRouteImport;
      parentRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/": {
      id: "/_authorization-gate/orgs/$orgName/";
      path: "/";
      fullPath: "/orgs/$orgName/";
      preLoaderRoute: typeof orgsOrgHomePageRouteImport;
      parentRoute: typeof orgsOrgLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/projects/{-$revisionId}": {
      id: "/_authorization-gate/wizard/admin/projects/{-$revisionId}";
      path: "/projects/{-$revisionId}";
      fullPath: "/wizard/admin/projects/{-$revisionId}";
      preLoaderRoute: typeof wizardAdminProjectsPageWizardAdminProjectsPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/package-review/{-$revisionId}": {
      id: "/_authorization-gate/wizard/admin/package-review/{-$revisionId}";
      path: "/package-review/{-$revisionId}";
      fullPath: "/wizard/admin/package-review/{-$revisionId}";
      preLoaderRoute: typeof wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/user/$ownerId/conversations/$conversationId": {
      id: "/_authorization-gate/user/$ownerId/conversations/$conversationId";
      path: "/user/$ownerId/conversations/$conversationId";
      fullPath: "/user/$ownerId/conversations/$conversationId";
      preLoaderRoute: typeof agentConversationsAgentConversationPageRouteImport;
      parentRoute: typeof rootLayoutAuthorizationGateRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId";
      path: "/packages/$packageId";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId";
      preLoaderRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRouteImport;
      parentRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId";
      path: "/projects/$projectId";
      fullPath: "/orgs/$orgName/projects/$projectId";
      preLoaderRoute: typeof projectsLayoutProjectLayoutRouteImport;
      parentRoute: typeof orgsOrgLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/users/": {
      id: "/_authorization-gate/wizard/admin/users/";
      path: "/users";
      fullPath: "/wizard/admin/users/";
      preLoaderRoute: typeof wizardAdminUsersPageWizardAdminUsersPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/user-throughput/": {
      id: "/_authorization-gate/wizard/admin/user-throughput/";
      path: "/user-throughput";
      fullPath: "/wizard/admin/user-throughput/";
      preLoaderRoute: typeof wizardAdminUserThroughputPageWizardAdminUserThroughputPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/plans/": {
      id: "/_authorization-gate/wizard/admin/plans/";
      path: "/plans";
      fullPath: "/wizard/admin/plans/";
      preLoaderRoute: typeof wizardAdminPlansPageWizardAdminPlansPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/members/": {
      id: "/_authorization-gate/wizard/admin/members/";
      path: "/members";
      fullPath: "/wizard/admin/members/";
      preLoaderRoute: typeof wizardAdminMembersPageWizardAdminMembersPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/eval/": {
      id: "/_authorization-gate/wizard/admin/eval/";
      path: "/eval";
      fullPath: "/wizard/admin/eval/";
      preLoaderRoute: typeof wizardAdminEvalPageWizardAdminEvalPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/error-codes/": {
      id: "/_authorization-gate/wizard/admin/error-codes/";
      path: "/error-codes";
      fullPath: "/wizard/admin/error-codes/";
      preLoaderRoute: typeof wizardAdminErrorCodesPageWizardAdminErrorCodesPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/data-specs/": {
      id: "/_authorization-gate/wizard/admin/data-specs/";
      path: "/data-specs";
      fullPath: "/wizard/admin/data-specs/";
      preLoaderRoute: typeof wizardAdminDataSpecsPageWizardAdminDataSpecsPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/tools/admin/pipeline-ops/": {
      id: "/_authorization-gate/tools/admin/pipeline-ops/";
      path: "/pipeline-ops";
      fullPath: "/tools/admin/pipeline-ops/";
      preLoaderRoute: typeof toolsAdminPipelineOpsPageAdminPipelineOpsPageRouteImport;
      parentRoute: typeof toolsAdminToolsAdminLayoutRoute;
    };
    "/_authorization-gate/tools/admin/customer-bom/": {
      id: "/_authorization-gate/tools/admin/customer-bom/";
      path: "/customer-bom";
      fullPath: "/tools/admin/customer-bom/";
      preLoaderRoute: typeof toolsAdminCustomerBomPageAdminCustomerBomPageRouteImport;
      parentRoute: typeof toolsAdminToolsAdminLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/raw/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/raw/";
      path: "/raw";
      fullPath: "/package-store/$packageFamilyId/raw/";
      preLoaderRoute: typeof packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRouteImport;
      parentRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/";
      path: "/packages";
      fullPath: "/package-store/$packageFamilyId/packages/";
      preLoaderRoute: typeof packageStorePackageFamilyEditorPackagesTabPackagesTabRouteImport;
      parentRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/general/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/general/";
      path: "/general";
      fullPath: "/package-store/$packageFamilyId/general/";
      preLoaderRoute: typeof packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRouteImport;
      parentRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/settings/": {
      id: "/_authorization-gate/orgs/$orgName/settings/";
      path: "/settings";
      fullPath: "/orgs/$orgName/settings/";
      preLoaderRoute: typeof orgsSettingsOrgSettingsPageRouteImport;
      parentRoute: typeof orgsOrgLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/": {
      id: "/_authorization-gate/orgs/$orgName/projects/";
      path: "/projects";
      fullPath: "/orgs/$orgName/projects/";
      preLoaderRoute: typeof projectsHomeProjectsHomePageRouteImport;
      parentRoute: typeof orgsOrgLayoutRoute;
    };
    "/_authorization-gate/wizard/admin/eval/operator/$userId": {
      id: "/_authorization-gate/wizard/admin/eval/operator/$userId";
      path: "/eval/operator/$userId";
      fullPath: "/wizard/admin/eval/operator/$userId";
      preLoaderRoute: typeof wizardAdminEvalPageWizardAdminEvalOperatorPageRouteImport;
      parentRoute: typeof wizardAdminWizardAdminLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/new/upload": {
      id: "/_authorization-gate/orgs/$orgName/projects/new/upload";
      path: "/projects/new/upload";
      fullPath: "/orgs/$orgName/projects/new/upload";
      preLoaderRoute: typeof projectsFileUploadNewProjectUploadPageRouteImport;
      parentRoute: typeof orgsOrgLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/";
      path: "/";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/";
      preLoaderRoute: typeof packageStorePackageEditorRootRedirectRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/";
      path: "/";
      fullPath: "/orgs/$orgName/projects/$projectId/";
      preLoaderRoute: typeof projectsProjectOverviewRootRedirectRouteImport;
      parentRoute: typeof projectsLayoutProjectLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/billing/plans/": {
      id: "/_authorization-gate/orgs/$orgName/billing/plans/";
      path: "/billing/plans";
      fullPath: "/orgs/$orgName/billing/plans/";
      preLoaderRoute: typeof orgsBillingPricingOptionsPagePricingOptionsPageRouteImport;
      parentRoute: typeof orgsOrgLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId";
      path: "/revisions/$revisionId";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId";
      preLoaderRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRouteImport;
      parentRoute: typeof projectsLayoutProjectLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signals/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signals/";
      path: "/signals";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/signals/";
      preLoaderRoute: typeof packageStorePackageEditorSignalsTabSignalsTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/";
      path: "/signal-drive-modes";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/signal-drive-modes/";
      preLoaderRoute: typeof packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/resources/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/resources/";
      path: "/resources";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/resources/";
      preLoaderRoute: typeof packageStorePackageEditorResourcesTabResourcesTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/raw/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/raw/";
      path: "/raw";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/raw/";
      preLoaderRoute: typeof packageStorePackageEditorRawTabPackageEditorRawTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/pinout/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/pinout/";
      path: "/pinout";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/pinout/";
      preLoaderRoute: typeof packageStorePackageEditorPinoutTabPinoutTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/parameters/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/parameters/";
      path: "/parameters";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/parameters/";
      preLoaderRoute: typeof packageStorePackageEditorParametersTabParametersTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/modes/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/modes/";
      path: "/modes";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/modes/";
      preLoaderRoute: typeof packageStorePackageEditorModesTabModesTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/models/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/models/";
      path: "/models";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/models/";
      preLoaderRoute: typeof packageStorePackageEditorModelsTabModelsTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/implementation-rules/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/implementation-rules/";
      path: "/implementation-rules";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/implementation-rules/";
      preLoaderRoute: typeof packageStorePackageEditorImplementationRulesTabImplementationRulesTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/general/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/general/";
      path: "/general";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/general/";
      preLoaderRoute: typeof packageStorePackageEditorGeneralTabGeneralTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/functions/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/functions/";
      path: "/functions";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/functions/";
      preLoaderRoute: typeof packageStorePackageEditorFunctionsTabFunctionsTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/datasheet/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/datasheet/";
      path: "/datasheet";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/datasheet/";
      preLoaderRoute: typeof packageStorePackageEditorDatasheetTabDatasheetTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/boundaries/": {
      id: "/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/boundaries/";
      path: "/boundaries";
      fullPath: "/package-store/$packageFamilyId/packages/$packageId/boundaries/";
      preLoaderRoute: typeof packageStorePackageEditorBoundariesTabBoundariesTabRouteImport;
      parentRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/overview/": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/overview/";
      path: "/overview";
      fullPath: "/orgs/$orgName/projects/$projectId/overview/";
      preLoaderRoute: typeof projectsProjectOverviewProjectOverviewPageRouteImport;
      parentRoute: typeof projectsLayoutProjectLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload";
      path: "/upload";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/upload";
      preLoaderRoute: typeof projectsFileUploadRevFileUploadPageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/results": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/results";
      path: "/results";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/results";
      preLoaderRoute: typeof resultsAnalysisResultsPageAnalysisResultsPageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor";
      path: "/resolution-editor";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/resolution-editor";
      preLoaderRoute: typeof resolutionEditorResolutionEditorPageResolutionEditorPageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas";
      path: "/design-canvas";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/design-canvas";
      preLoaderRoute: typeof designCanvasDesignCanvasPageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram";
      path: "/block-diagram";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/block-diagram";
      preLoaderRoute: typeof blockDiagramBlockDiagramPageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings";
      path: "/ai-findings";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/ai-findings";
      preLoaderRoute: typeof aiFindingsAiFindingsPageAiFindingsPageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/";
      path: "/";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/";
      preLoaderRoute: typeof projectsRevisionLayoutRootRedirectRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
    "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator": {
      id: "/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator";
      path: "/component-inference/$referenceDesignator";
      fullPath: "/orgs/$orgName/projects/$projectId/revisions/$revisionId/component-inference/$referenceDesignator";
      preLoaderRoute: typeof componentInferenceComponentInferencePageRouteImport;
      parentRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRoute;
    };
  }
}

interface wizardAdminWizardAdminLayoutRouteChildren {
  wizardAdminGeneralPageWizardAdminGeneralPageRoute: typeof wizardAdminGeneralPageWizardAdminGeneralPageRoute;
  wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute: typeof wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute;
  wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute: typeof wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute;
  wizardAdminEvalPageWizardAdminEvalPageRoute: typeof wizardAdminEvalPageWizardAdminEvalPageRoute;
  wizardAdminMembersPageWizardAdminMembersPageRoute: typeof wizardAdminMembersPageWizardAdminMembersPageRoute;
  wizardAdminPlansPageWizardAdminPlansPageRoute: typeof wizardAdminPlansPageWizardAdminPlansPageRoute;
  wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute: typeof wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute;
  wizardAdminUsersPageWizardAdminUsersPageRoute: typeof wizardAdminUsersPageWizardAdminUsersPageRoute;
  wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute: typeof wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute;
  wizardAdminProjectsPageWizardAdminProjectsPageRoute: typeof wizardAdminProjectsPageWizardAdminProjectsPageRoute;
  wizardAdminEvalPageWizardAdminEvalOperatorPageRoute: typeof wizardAdminEvalPageWizardAdminEvalOperatorPageRoute;
}

const wizardAdminWizardAdminLayoutRouteChildren: wizardAdminWizardAdminLayoutRouteChildren =
  {
    wizardAdminGeneralPageWizardAdminGeneralPageRoute:
      wizardAdminGeneralPageWizardAdminGeneralPageRoute,
    wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute:
      wizardAdminDataSpecsPageWizardAdminDataSpecsPageRoute,
    wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute:
      wizardAdminErrorCodesPageWizardAdminErrorCodesPageRoute,
    wizardAdminEvalPageWizardAdminEvalPageRoute:
      wizardAdminEvalPageWizardAdminEvalPageRoute,
    wizardAdminMembersPageWizardAdminMembersPageRoute:
      wizardAdminMembersPageWizardAdminMembersPageRoute,
    wizardAdminPlansPageWizardAdminPlansPageRoute:
      wizardAdminPlansPageWizardAdminPlansPageRoute,
    wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute:
      wizardAdminUserThroughputPageWizardAdminUserThroughputPageRoute,
    wizardAdminUsersPageWizardAdminUsersPageRoute:
      wizardAdminUsersPageWizardAdminUsersPageRoute,
    wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute:
      wizardAdminProjectsPagePackageReviewWizardAdminPackageReviewPageRoute,
    wizardAdminProjectsPageWizardAdminProjectsPageRoute:
      wizardAdminProjectsPageWizardAdminProjectsPageRoute,
    wizardAdminEvalPageWizardAdminEvalOperatorPageRoute:
      wizardAdminEvalPageWizardAdminEvalOperatorPageRoute,
  };

const wizardAdminWizardAdminLayoutRouteWithChildren =
  wizardAdminWizardAdminLayoutRoute._addFileChildren(
    wizardAdminWizardAdminLayoutRouteChildren,
  );

interface wizardWizardLayoutRouteChildren {
  wizardHomePageWizardHomePageRoute: typeof wizardHomePageWizardHomePageRoute;
  wizardAdminWizardAdminLayoutRoute: typeof wizardAdminWizardAdminLayoutRouteWithChildren;
  wizardGoPageWizardGoPageRoute: typeof wizardGoPageWizardGoPageRoute;
  wizardQueuePageWizardQueuePageRoute: typeof wizardQueuePageWizardQueuePageRoute;
}

const wizardWizardLayoutRouteChildren: wizardWizardLayoutRouteChildren = {
  wizardHomePageWizardHomePageRoute: wizardHomePageWizardHomePageRoute,
  wizardAdminWizardAdminLayoutRoute:
    wizardAdminWizardAdminLayoutRouteWithChildren,
  wizardGoPageWizardGoPageRoute: wizardGoPageWizardGoPageRoute,
  wizardQueuePageWizardQueuePageRoute: wizardQueuePageWizardQueuePageRoute,
};

const wizardWizardLayoutRouteWithChildren =
  wizardWizardLayoutRoute._addFileChildren(wizardWizardLayoutRouteChildren);

interface projectsRevisionLayoutProjectRevisionLayoutRouteChildren {
  projectsRevisionLayoutRootRedirectRoute: typeof projectsRevisionLayoutRootRedirectRoute;
  aiFindingsAiFindingsPageAiFindingsPageRoute: typeof aiFindingsAiFindingsPageAiFindingsPageRoute;
  blockDiagramBlockDiagramPageRoute: typeof blockDiagramBlockDiagramPageRoute;
  designCanvasDesignCanvasPageRoute: typeof designCanvasDesignCanvasPageRoute;
  resolutionEditorResolutionEditorPageResolutionEditorPageRoute: typeof resolutionEditorResolutionEditorPageResolutionEditorPageRoute;
  resultsAnalysisResultsPageAnalysisResultsPageRoute: typeof resultsAnalysisResultsPageAnalysisResultsPageRoute;
  projectsFileUploadRevFileUploadPageRoute: typeof projectsFileUploadRevFileUploadPageRoute;
  componentInferenceComponentInferencePageRoute: typeof componentInferenceComponentInferencePageRoute;
}

const projectsRevisionLayoutProjectRevisionLayoutRouteChildren: projectsRevisionLayoutProjectRevisionLayoutRouteChildren =
  {
    projectsRevisionLayoutRootRedirectRoute:
      projectsRevisionLayoutRootRedirectRoute,
    aiFindingsAiFindingsPageAiFindingsPageRoute:
      aiFindingsAiFindingsPageAiFindingsPageRoute,
    blockDiagramBlockDiagramPageRoute: blockDiagramBlockDiagramPageRoute,
    designCanvasDesignCanvasPageRoute: designCanvasDesignCanvasPageRoute,
    resolutionEditorResolutionEditorPageResolutionEditorPageRoute:
      resolutionEditorResolutionEditorPageResolutionEditorPageRoute,
    resultsAnalysisResultsPageAnalysisResultsPageRoute:
      resultsAnalysisResultsPageAnalysisResultsPageRoute,
    projectsFileUploadRevFileUploadPageRoute:
      projectsFileUploadRevFileUploadPageRoute,
    componentInferenceComponentInferencePageRoute:
      componentInferenceComponentInferencePageRoute,
  };

const projectsRevisionLayoutProjectRevisionLayoutRouteWithChildren =
  projectsRevisionLayoutProjectRevisionLayoutRoute._addFileChildren(
    projectsRevisionLayoutProjectRevisionLayoutRouteChildren,
  );

interface projectsLayoutProjectLayoutRouteChildren {
  projectsProjectOverviewRootRedirectRoute: typeof projectsProjectOverviewRootRedirectRoute;
  projectsProjectOverviewProjectOverviewPageRoute: typeof projectsProjectOverviewProjectOverviewPageRoute;
  projectsRevisionLayoutProjectRevisionLayoutRoute: typeof projectsRevisionLayoutProjectRevisionLayoutRouteWithChildren;
}

const projectsLayoutProjectLayoutRouteChildren: projectsLayoutProjectLayoutRouteChildren =
  {
    projectsProjectOverviewRootRedirectRoute:
      projectsProjectOverviewRootRedirectRoute,
    projectsProjectOverviewProjectOverviewPageRoute:
      projectsProjectOverviewProjectOverviewPageRoute,
    projectsRevisionLayoutProjectRevisionLayoutRoute:
      projectsRevisionLayoutProjectRevisionLayoutRouteWithChildren,
  };

const projectsLayoutProjectLayoutRouteWithChildren =
  projectsLayoutProjectLayoutRoute._addFileChildren(
    projectsLayoutProjectLayoutRouteChildren,
  );

interface orgsOrgLayoutRouteChildren {
  orgsOrgHomePageRoute: typeof orgsOrgHomePageRoute;
  projectsHomeProjectsHomePageRoute: typeof projectsHomeProjectsHomePageRoute;
  orgsSettingsOrgSettingsPageRoute: typeof orgsSettingsOrgSettingsPageRoute;
  projectsLayoutProjectLayoutRoute: typeof projectsLayoutProjectLayoutRouteWithChildren;
  orgsBillingPricingOptionsPagePricingOptionsPageRoute: typeof orgsBillingPricingOptionsPagePricingOptionsPageRoute;
  projectsFileUploadNewProjectUploadPageRoute: typeof projectsFileUploadNewProjectUploadPageRoute;
}

const orgsOrgLayoutRouteChildren: orgsOrgLayoutRouteChildren = {
  orgsOrgHomePageRoute: orgsOrgHomePageRoute,
  projectsHomeProjectsHomePageRoute: projectsHomeProjectsHomePageRoute,
  orgsSettingsOrgSettingsPageRoute: orgsSettingsOrgSettingsPageRoute,
  projectsLayoutProjectLayoutRoute:
    projectsLayoutProjectLayoutRouteWithChildren,
  orgsBillingPricingOptionsPagePricingOptionsPageRoute:
    orgsBillingPricingOptionsPagePricingOptionsPageRoute,
  projectsFileUploadNewProjectUploadPageRoute:
    projectsFileUploadNewProjectUploadPageRoute,
};

const orgsOrgLayoutRouteWithChildren = orgsOrgLayoutRoute._addFileChildren(
  orgsOrgLayoutRouteChildren,
);

interface packageStorePackageEditorLayoutPackageEditorLayoutRouteChildren {
  packageStorePackageEditorRootRedirectRoute: typeof packageStorePackageEditorRootRedirectRoute;
  packageStorePackageEditorBoundariesTabBoundariesTabRoute: typeof packageStorePackageEditorBoundariesTabBoundariesTabRoute;
  packageStorePackageEditorDatasheetTabDatasheetTabRoute: typeof packageStorePackageEditorDatasheetTabDatasheetTabRoute;
  packageStorePackageEditorFunctionsTabFunctionsTabRoute: typeof packageStorePackageEditorFunctionsTabFunctionsTabRoute;
  packageStorePackageEditorGeneralTabGeneralTabRoute: typeof packageStorePackageEditorGeneralTabGeneralTabRoute;
  packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute: typeof packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute;
  packageStorePackageEditorModelsTabModelsTabRoute: typeof packageStorePackageEditorModelsTabModelsTabRoute;
  packageStorePackageEditorModesTabModesTabRoute: typeof packageStorePackageEditorModesTabModesTabRoute;
  packageStorePackageEditorParametersTabParametersTabRoute: typeof packageStorePackageEditorParametersTabParametersTabRoute;
  packageStorePackageEditorPinoutTabPinoutTabRoute: typeof packageStorePackageEditorPinoutTabPinoutTabRoute;
  packageStorePackageEditorRawTabPackageEditorRawTabRoute: typeof packageStorePackageEditorRawTabPackageEditorRawTabRoute;
  packageStorePackageEditorResourcesTabResourcesTabRoute: typeof packageStorePackageEditorResourcesTabResourcesTabRoute;
  packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute: typeof packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute;
  packageStorePackageEditorSignalsTabSignalsTabRoute: typeof packageStorePackageEditorSignalsTabSignalsTabRoute;
}

const packageStorePackageEditorLayoutPackageEditorLayoutRouteChildren: packageStorePackageEditorLayoutPackageEditorLayoutRouteChildren =
  {
    packageStorePackageEditorRootRedirectRoute:
      packageStorePackageEditorRootRedirectRoute,
    packageStorePackageEditorBoundariesTabBoundariesTabRoute:
      packageStorePackageEditorBoundariesTabBoundariesTabRoute,
    packageStorePackageEditorDatasheetTabDatasheetTabRoute:
      packageStorePackageEditorDatasheetTabDatasheetTabRoute,
    packageStorePackageEditorFunctionsTabFunctionsTabRoute:
      packageStorePackageEditorFunctionsTabFunctionsTabRoute,
    packageStorePackageEditorGeneralTabGeneralTabRoute:
      packageStorePackageEditorGeneralTabGeneralTabRoute,
    packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute:
      packageStorePackageEditorImplementationRulesTabImplementationRulesTabRoute,
    packageStorePackageEditorModelsTabModelsTabRoute:
      packageStorePackageEditorModelsTabModelsTabRoute,
    packageStorePackageEditorModesTabModesTabRoute:
      packageStorePackageEditorModesTabModesTabRoute,
    packageStorePackageEditorParametersTabParametersTabRoute:
      packageStorePackageEditorParametersTabParametersTabRoute,
    packageStorePackageEditorPinoutTabPinoutTabRoute:
      packageStorePackageEditorPinoutTabPinoutTabRoute,
    packageStorePackageEditorRawTabPackageEditorRawTabRoute:
      packageStorePackageEditorRawTabPackageEditorRawTabRoute,
    packageStorePackageEditorResourcesTabResourcesTabRoute:
      packageStorePackageEditorResourcesTabResourcesTabRoute,
    packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute:
      packageStorePackageEditorSignalDriveModesTabSignalDriveModesTabRoute,
    packageStorePackageEditorSignalsTabSignalsTabRoute:
      packageStorePackageEditorSignalsTabSignalsTabRoute,
  };

const packageStorePackageEditorLayoutPackageEditorLayoutRouteWithChildren =
  packageStorePackageEditorLayoutPackageEditorLayoutRoute._addFileChildren(
    packageStorePackageEditorLayoutPackageEditorLayoutRouteChildren,
  );

interface packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteChildren {
  packageStorePackageFamilyEditorRootRedirectRoute: typeof packageStorePackageFamilyEditorRootRedirectRoute;
  packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute: typeof packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute;
  packageStorePackageFamilyEditorPackagesTabPackagesTabRoute: typeof packageStorePackageFamilyEditorPackagesTabPackagesTabRoute;
  packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute: typeof packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute;
  packageStorePackageEditorLayoutPackageEditorLayoutRoute: typeof packageStorePackageEditorLayoutPackageEditorLayoutRouteWithChildren;
}

const packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteChildren: packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteChildren =
  {
    packageStorePackageFamilyEditorRootRedirectRoute:
      packageStorePackageFamilyEditorRootRedirectRoute,
    packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute:
      packageStorePackageFamilyEditorGeneralTabFamilyGeneralTabRoute,
    packageStorePackageFamilyEditorPackagesTabPackagesTabRoute:
      packageStorePackageFamilyEditorPackagesTabPackagesTabRoute,
    packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute:
      packageStorePackageFamilyEditorRawTabPackageFamilyEditorRawTabRoute,
    packageStorePackageEditorLayoutPackageEditorLayoutRoute:
      packageStorePackageEditorLayoutPackageEditorLayoutRouteWithChildren,
  };

const packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteWithChildren =
  packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute._addFileChildren(
    packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteChildren,
  );

interface toolsAdminToolsAdminLayoutRouteChildren {
  toolsAdminCustomerBomPageAdminCustomerBomPageRoute: typeof toolsAdminCustomerBomPageAdminCustomerBomPageRoute;
  toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute: typeof toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute;
}

const toolsAdminToolsAdminLayoutRouteChildren: toolsAdminToolsAdminLayoutRouteChildren =
  {
    toolsAdminCustomerBomPageAdminCustomerBomPageRoute:
      toolsAdminCustomerBomPageAdminCustomerBomPageRoute,
    toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute:
      toolsAdminPipelineOpsPageAdminPipelineOpsPageRoute,
  };

const toolsAdminToolsAdminLayoutRouteWithChildren =
  toolsAdminToolsAdminLayoutRoute._addFileChildren(
    toolsAdminToolsAdminLayoutRouteChildren,
  );

interface rootLayoutAuthorizationGateRouteChildren {
  homePageHomePageRoute: typeof homePageHomePageRoute;
  auth0CallbackPageRoute: typeof auth0CallbackPageRoute;
  projectsRedirectRoute: typeof projectsRedirectRoute;
  retrievalExplorerRetrievalExplorerPageRoute: typeof retrievalExplorerRetrievalExplorerPageRoute;
  wizardWizardLayoutRoute: typeof wizardWizardLayoutRouteWithChildren;
  documentsPendingPageRoute: typeof documentsPendingPageRoute;
  logInPageRoute: typeof logInPageRoute;
  logOutPageRoute: typeof logOutPageRoute;
  loggedOutPageRoute: typeof loggedOutPageRoute;
  manufacturerIndexManufacturerIndexRoute: typeof manufacturerIndexManufacturerIndexRoute;
  packageStoreHomePackageStoreHomeRoute: typeof packageStoreHomePackageStoreHomeRoute;
  tagsTagsPageRoute: typeof tagsTagsPageRoute;
  verifyEmailPageRoute: typeof verifyEmailPageRoute;
  workEmailRequiredPageRoute: typeof workEmailRequiredPageRoute;
  orgsOrgLayoutRoute: typeof orgsOrgLayoutRouteWithChildren;
  packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute: typeof packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteWithChildren;
  toolsAdminToolsAdminLayoutRoute: typeof toolsAdminToolsAdminLayoutRouteWithChildren;
  pdfElementsViewerPdfElementsViewerPageRoute: typeof pdfElementsViewerPdfElementsViewerPageRoute;
  agentConversationsAgentConversationPageRoute: typeof agentConversationsAgentConversationPageRoute;
}

const rootLayoutAuthorizationGateRouteChildren: rootLayoutAuthorizationGateRouteChildren =
  {
    homePageHomePageRoute: homePageHomePageRoute,
    auth0CallbackPageRoute: auth0CallbackPageRoute,
    projectsRedirectRoute: projectsRedirectRoute,
    retrievalExplorerRetrievalExplorerPageRoute:
      retrievalExplorerRetrievalExplorerPageRoute,
    wizardWizardLayoutRoute: wizardWizardLayoutRouteWithChildren,
    documentsPendingPageRoute: documentsPendingPageRoute,
    logInPageRoute: logInPageRoute,
    logOutPageRoute: logOutPageRoute,
    loggedOutPageRoute: loggedOutPageRoute,
    manufacturerIndexManufacturerIndexRoute:
      manufacturerIndexManufacturerIndexRoute,
    packageStoreHomePackageStoreHomeRoute:
      packageStoreHomePackageStoreHomeRoute,
    tagsTagsPageRoute: tagsTagsPageRoute,
    verifyEmailPageRoute: verifyEmailPageRoute,
    workEmailRequiredPageRoute: workEmailRequiredPageRoute,
    orgsOrgLayoutRoute: orgsOrgLayoutRouteWithChildren,
    packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRoute:
      packageStorePackageFamilyEditorLayoutPackageFamilyEditorLayoutRouteWithChildren,
    toolsAdminToolsAdminLayoutRoute:
      toolsAdminToolsAdminLayoutRouteWithChildren,
    pdfElementsViewerPdfElementsViewerPageRoute:
      pdfElementsViewerPdfElementsViewerPageRoute,
    agentConversationsAgentConversationPageRoute:
      agentConversationsAgentConversationPageRoute,
  };

const rootLayoutAuthorizationGateRouteWithChildren =
  rootLayoutAuthorizationGateRoute._addFileChildren(
    rootLayoutAuthorizationGateRouteChildren,
  );

const rootRouteChildren: RootRouteChildren = {
  rootLayoutAuthorizationGateRoute:
    rootLayoutAuthorizationGateRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
